import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./DaVo.png";

export default function PortaalPage() {
  // Houd de lijst met projecten bij; elk item heeft projectId, projectName en logoPath.
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    async function fetchProjects() {
      setLoading(true);
      try {
        const response = await fetch("/api/projects");
        if (response.ok) {
          const data = await response.json();
          const items = Array.isArray(data) ? data : data.projects || [];
          setProjects(items);
        } else {
          console.error(
            `Failed to load projects (HTTP ${response.status})`
          );
        }
      } catch (error) {
        console.error("Error while loading projects:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchProjects();
  }, [refreshKey]);

  return (
    <div className="login-shell">
      <div className="login-logo-wrapper">
        <a
          href="https://datavolwassenheid.nl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ga naar Datavolwassenheid.nl"
        >
          <img
            src={logo}
            alt="Datavolwassenheid.nl"
            className="login-logo-top"
          />
        </a>
      </div>

      <div className="portal-card card-3d">
        <h1 className="portal-title">Mijn Boardroom</h1>
        <button
          className="portal-refresh-btn"
          onClick={() => setRefreshKey((k) => k + 1)}
          disabled={loading}
          aria-label="Vernieuwen"
          title="Vernieuwen"
        >
          ↻
        </button>
        <hr className="login-divider" />
        {loading ? (
          <div className="portal-loading">
            <div className="portal-spinner" />
            <p className="portal-loading-text">Projecten worden geladen…</p>
          </div>
        ) : projects.length === 0 ? (
          <p className="portal-empty">Geen projecten gevonden. Klik op vernieuwen.</p>
        ) : (
          <div className="portal-grid">
            {projects.map((project) => (
              <Link
                key={project.ProjectId}
                to={`/${project.DashboardType === "pl" ? "pl" : project.DashboardType === "vw" ? "vw" : "ea"}/${project.ProjectId}`}
                className="project-card"
              >
                {project.LogoPath && (
                  <div className="logo-tile logo-tile--card project-logo-tile">
                    <img
                      className="project-logo"
                      src={process.env.PUBLIC_URL + project.LogoPath}
                      alt={project.ProjectName}
                    />
                  </div>
                )}
                <span className="project-name">{project.ProjectName}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}